/**
 * File node data with nested structure.
 * Each node has a filename, and a type or a list of children.
 */
 export class FileNode {
    children?: FileNode[] | undefined;
    name: string | undefined;
    isFolder: boolean;
    path: string;
}

  /** Flat node with expandable and level information */
 export class FileFlatNode {
    constructor(
      public expandable: boolean, public path: string, public filename: string, public level: number) {}
}
